import { contentsType } from '../types';

const comparisonContents: Array<contentsType> = [
  {
    title: 'Auto-Generated Peers',
    description:
      'Sistem kami secara otomatis akan membantu membandingkan emiten pilihan Anda dengan emiten sejenisnya sehingga tidak perlu lagi repot dan bingung mencari perbandingan emiten yang sesuai.',
    image: 'Comparison_Auto_Generate_Blue.jpg',
  },
  {
    title: 'Komparasi secara Rinci',
    description:
      'Dilengkapi dengan puluhan rasio dan financial metrics, laukan komparasi emiten dari berbagai aspek secara rinci dan mudah. Ditambah adanya angka rata-rata untuk masing-masing industri dan sektor emiten terkait sebagai pembanding untuk membantu memilih emiten yang paling sesuai dengan kriteria.',
    image: 'Comparison_Rinci_Blue.jpg',
  },
];

export default comparisonContents;
